import React from "react";
import { Slider } from "@/components/ui/slider";
import { useLang } from "@/context/LanguageContext";
import { HeartHandshake } from "lucide-react";
import { eur } from "@/components/PublicationPlanPicker";

export default function ContributionSlider({ value, onChange, max = 50 }) {
  const { t } = useLang();
  return (
    <div className="rounded-2xl border border-findo-red/25 bg-findo-red/[0.04] p-4" data-testid="contribution-slider-block">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-semibold text-findo-navy inline-flex items-center gap-1.5">
          <HeartHandshake size={15} className="text-findo-red" /> {t("fa.contribTitle")}
        </p>
        <span className="text-lg font-extrabold text-findo-red tabular-nums" data-testid="contribution-amount">
          {value > 0 ? eur(value) : t("fa.contribNone")}
        </span>
      </div>
      <p className="text-xs text-slate-500 mt-1">{t("fa.contribSub")}</p>
      <Slider value={[value]} min={0} max={max} step={1} onValueChange={(v) => onChange(v[0])}
        className="mt-4 [&_[role=slider]]:h-5 [&_[role=slider]]:w-5 [&_[role=slider]]:border-findo-red [&>span:first-child>span]:bg-findo-red"
        data-testid="contribution-slider" />
      <div className="mt-1.5 flex justify-between text-[11px] text-slate-400"><span>0 €</span><span>{max} €</span></div>
    </div>
  );
}
